import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import { useFormik } from "formik";
import Dropzone from "react-dropzone";
import Select from "react-select";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CategoryServices from "../../../services/OrderingServices/CategoryService";
import ItemService from "../../../services/OrderingServices/ItemService";
import restroOrder from "../../../assets/orderingSystem/restrologo.png";

const MenuItem = () => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [filters, setFilters] = useState({
    namesearch: "",
    PriceMin: "",
    PriceMax: "",
    CategoryId: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const toggleModal = (itemId) => {
    setShow(true);
    setSelectedItemId(itemId);
  };
  const toggleModal1 = () => setShow(false);

  const customStyles = {
    headCells: { style: { fontSize: "0.92rem", fontWeight: 610 } },
    rows: { style: { fontSize: "0.9rem" } },
  };

  // Fetch items from API
  async function fetchItemList(
    page = currentPage,
    size = pageSize,
    currentFilters = debouncedFilters
  ) {
    try {
      setLoading(true);
      const response = await ItemService.itemList({
        namesearch: currentFilters.namesearch,
        PriceMin: currentFilters.PriceMin,
        PriceMax: currentFilters.PriceMax,
        CategoryId: currentFilters.CategoryId,
        page,
        pageSize: size,
      });

      const indexedData = response?.items.map((item, index) => ({
        ...item,
        sn: (page - 1) * size + index + 1, // Calculate serial number
      }));

      setItemList(indexedData);
      setTotalRows(response?.totalCount || 0); // Use totalCount from API response
      setLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      setLoading(false);
    }
  }

  // Update filters when searchQuery changes
  useEffect(() => {
    setFilters((prev) => ({ ...prev, namesearch: searchQuery }));
  }, [searchQuery]);

  // Debounce filter changes
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  // Fetch items when page, pageSize, or debouncedFilters change
  useEffect(() => {
    fetchItemList(currentPage, pageSize, debouncedFilters);
  }, [currentPage, pageSize, debouncedFilters]);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDelete();
  };
  const handleDelete = async () => {
    if (selectedItem) {
      try {
        await ItemService.deleteItem(selectedItem);
        fetchItemList(currentPage, pageSize, debouncedFilters);
        toast.success("Product Deleted Successfully");
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to delete product"
        );
      } finally {
        toggleDelete();
        setSelectedItem(null);
      }
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row) => row.sn,
      sortable: true,
      width: "75px",
    },
    {
      name: "Product Name",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={row.displayImage?.getCDNUrl() || restroOrder}
            alt={row.name}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
          <span
            title={row.name} // shows full name on hover
            style={{
              maxWidth: "150px", // optional: control width
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row.name}
          </span>
        </div>
      ),
      sortable: true,
    },

    {
      name: "Category",
      selector: (row) => row.categoryName,
      sortable: true,
    },
    {
      name: "Unit",
      selector: (row) => row.unitName || "",
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price || "0",
      right: true,
      sortable: true,
    },
    {
      name: "IsPOS?",

      selector: (row) => (
        <span className={`badge ${row.isHidden ? "bg-danger" : "bg-success"}`}>
          {row.isHidden ? "Unavailable" : "Available"}
        </span>
      ),

      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <ButtonGroup className="d-flex gap-2">
          <Link to={`/menu-item/update/${row.id}`}>
            <Button color="btn btn-soft-warning" className="btn-sm ms-1">
              <i className="ri-edit-line" />
            </Button>
          </Link>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
          <Link to={`/item/detail/${row.id}`}>
            <Button color="btn btn-soft-success" className="btn-sm">
              <i className="bx bx-show" />
            </Button>
          </Link>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  const formik = useFormik({
    initialValues: { formfile: "" },
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("id", selectedItemId);
        formData.append("formfile", values.formfile);
        await ItemService.updateItemImage(selectedItemId, formData);
        toast.success("Image Updated Successfully");
        fetchItemList(currentPage, pageSize, debouncedFilters);
        setShow(false);
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to update image");
      }
    },
  });

  const handleAcceptedFiles = (files) => {
    const formattedFiles = files.map((file) => ({
      name: file.name,
      path: file.path,
      preview: URL.createObjectURL(file),
    }));
    setSelectedFiles(formattedFiles);
    formik.setFieldValue("formfile", files[0]);
  };

  const handleFileRemove = (index) => {
    const files = [...selectedFiles];
    files.splice(index, 1);
    setSelectedFiles(files);
    formik.setFieldValue("formfile", "");
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Product List" pageTitle="Product Management" />

        <Row>
          <Col lg={4} className="mb-2">
            <Input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by Product Name"
            />
          </Col>
          <Col lg={4} xs={10} className="mb-2">
            <div className="d-flex gap-2 justify-content-center align-content-center  align-items-center">
              <Input
                type="number"
                value={filters.PriceMin}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, PriceMin: e.target.value }))
                }
                placeholder="Min Price"
              />
              <div>
                <i class="bx bx-expand-horizontal"></i>{" "}
              </div>
              <Input
                type="number"
                value={filters.PriceMax}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, PriceMax: e.target.value }))
                }
                placeholder="Max Price"
              />
            </div>
          </Col>

          {/* <Col lg={2}>
            <Input
              type="number"
              value={filters.CategoryId}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, CategoryId: e.target.value }))
              }
              placeholder="Category ID"
            />
          </Col> */}
          <Col className="mb-2 d-lg-block d-none">
            <Link to="/menu-item/create">
              <button className="btn btn-success px-1 px-sm-2">
                + Add Product
              </button>
            </Link>
          </Col>
          <Col className="mb-2 d-lg-none d-block" xs={2}>
            <Link to="/menu-item/create">
              <button className="btn btn-success ">+</button>
            </Link>
          </Col>
        </Row>

        <div className="d-lg-block d-md-block d-none">
          <DataTable
            responsive
            striped
            pagination
            fixedHeader
            highlightOnHover
            pointerOnHover
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationPerPage={pageSize}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
              setPageSize(newPerPage);
              setCurrentPage(page);
            }}
            progressComponent={
              <div className="my-3">
                <Triangle visible height="80" width="80" color="#5B71B9" />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={itemList} // Use itemList directly since filtering is server-side
          />
        </div>
        <div className="d-block d-md-none d-lg-none">
          {loading ? (
            <div className="my-5 d-flex justify-content-center d-lg-none d-block">
              <Triangle
                visible={true}
                height="60"
                width="60"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
            </div>
          ) : (
            <>
              {itemList?.map((item, index) => (
                <Card
                  key={item.id || index}
                  className="mb-3 shadow-sm d-block d-md-none d-lg-none mt-2"
                  onClick={(e) => {
                    e.stopPropagation(); // prevents parent click handlers
                    navigate(`/item/detail/${item?.id}`);
                  }}
                >
                  <CardBody>
                    <Row>
                      <Col xs={10}>
                        <h6 className="mb-2">{`${item.name} `}</h6>
                        <h6 className="mb-2 text-muted">
                          Category: {item?.categoryName}
                        </h6>
                        <h6 className="mb-2">Unit: {item?.unitName}</h6>
                        <h6 className="mb-2">
                          <strong>Price:</strong> {item?.price || "none"}
                        </h6>
                        <h6 className="mb-0">
                          <strong>IsPos?:</strong>{" "}
                          <span
                            className={`badge ${
                              item.isHidden ? "bg-danger" : "bg-success"
                            }`}
                          >
                            {item.isHidden ? "Unavailable" : "Available"}
                          </span>
                        </h6>
                      </Col>
                      <Col xs={2}>
                        <div>
                          <Dropdown
                            isOpen={item.dropdownOpen || false}
                            toggle={(e) => {
                              e.stopPropagation(); // prevents parent click handlers
                              setItemList((prev) =>
                                prev.map(
                                  (customer) =>
                                    customer.id === item.id
                                      ? {
                                          ...customer,
                                          dropdownOpen: !customer.dropdownOpen,
                                        }
                                      : { ...customer, dropdownOpen: false } // close all others
                                )
                              );
                            }}
                            direction="down"
                          >
                            <DropdownToggle
                              color="primary"
                              outline
                              className="btn-sm shadow-sm rounded-circle"
                            >
                              <i className="ri-more-2-fill"></i>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <DropdownItem
                                onClick={() => {
                                  navigate(`/menu-item/update/${item?.id}`);
                                }}
                              >
                                <i className="ri-edit-line text-warning me-2"></i>{" "}
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => handleDeleteClick(item.id)}
                              >
                                <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                                Delete
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ))}

              {/* Pagination for Mobile View */}
              {itemList?.length > 0 && (
                <div className="d-flex justify-content-center align-content-center align-items-center d-lg-none  sticky-bottom bottom-0">
                  <nav>
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                        >
                          <i class="ri-arrow-left-s-line"></i>
                        </button>
                      </li>
                      {[...Array(Math.ceil(totalRows / pageSize)).keys()].map(
                        (page) => (
                          <li
                            key={page + 1}
                            className={`page-item ${
                              currentPage === page + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(page + 1)}
                            >
                              {page + 1}
                            </button>
                          </li>
                        )
                      )}
                      <li
                        className={`page-item ${
                          currentPage === Math.ceil(totalRows / pageSize)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(
                                prev + 1,
                                Math.ceil(totalRows / pageSize)
                              )
                            )
                          }
                          disabled={
                            currentPage === Math.ceil(totalRows / pageSize)
                          }
                        >
                          <i class="ri-arrow-right-s-line"></i>{" "}
                        </button>
                      </li>
                    </ul>
                  </nav>
                  {/* <div className="d-flex justify-content-center align-items-center ">
                  <select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      setCurrentPage(1); // Reset to first page when page size changes
                    }}
                    className="form-select"
                    
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                
                </div> */}
                </div>
              )}
            </>
          )}
        </div>

        <Modal isOpen={show} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>Update Item Image</ModalHeader>
          <ModalBody>
            <form onSubmit={formik.handleSubmit}>
              <Dropzone onDrop={handleAcceptedFiles}>
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone dz-clickable">
                    <div
                      className="dz-message needsclick mb-2"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                      <h4 className="fs-15 pt-3">
                        Drop files or click to upload.
                      </h4>
                      <h4 className="fs-14 text-muted">
                        Max Upload Size 10MB.
                      </h4>
                    </div>
                  </div>
                )}
              </Dropzone>

              {selectedFiles.map((f, i) => (
                <div key={i} className="mb-2 border dz-processing">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <img
                        height="100"
                        className="avatar-sm rounded bg-light"
                        alt={f.name}
                        src={f.preview}
                      />
                    </Col>
                    <Col>
                      <p className="mb-0 text-muted">{f.name}</p>
                    </Col>
                    <Col lg={2}>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleFileRemove(i)}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              <div className="text-end mt-3">
                <Button
                  type="submit"
                  color="success"
                  disabled={!formik.values.formfile}
                >
                  Update Image
                </Button>
              </div>
            </form>
          </ModalBody>
        </Modal>

        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </div>
    </Container>
  );
};

export default MenuItem;
